import { CPC_REFERRER_SEARCH_PARAM_KEY } from '../../constants/catalog-cpc';
import { useOrigin } from '../../providers/OriginProvider';

export const useGenerateSingleProductHref = (slug: string) => {
  const { baseUrl, isSameOrigin } = useOrigin();
  const tenant = process.env.NEXT_PUBLIC_TENANT;

  if (isSameOrigin || tenant === undefined) {
    return `${baseUrl}/${slug}/`;
  }

  return `${baseUrl}/${slug}/?${CPC_REFERRER_SEARCH_PARAM_KEY}=${process.env.NEXT_PUBLIC_TENANT}`;
};
